"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var pick_react_known_prop_1 = require("pick-react-known-prop");
var DataSeries = /** @class */ (function (_super) {
    __extends(DataSeries, _super);
    function DataSeries() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataSeries.prototype.render = function () {
        var self = this;
        var _a = this.props, xScale = _a.xScale, yScale = _a.yScale, data = _a.data, interpolate = _a.interpolate, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, area = _a.area, size = _a.size, chartType = _a.chartType, linePath = _a.linePath, areaPath = _a.areaPath, pathGenerator = _a.pathGenerator, showCircles = _a.showCircles, key = _a.key, onCircleMouseOut = _a.onCircleMouseOut, onCircleMouseOver = _a.onCircleMouseOver, circleElements = _a.circleElements, estimateDataPoint = _a.estimateDataPoint, restProps = __rest(_a, ["xScale", "yScale", "data", "interpolate", "xAxisKey", "yAxisKey", "area", "size", "chartType", "linePath", "areaPath", "pathGenerator", "showCircles", "key", "onCircleMouseOut", "onCircleMouseOver", "circleElements", "estimateDataPoint"]);
        var circlesElementsOrNull = circleElements || React.createElement(Circles, __assign({}, this.props));
        if (!showCircles) {
            circlesElementsOrNull = null;
        }
        // Disable showing circle elements forever due to new interaction design.
        // Not removing the code for now until we're certain this is the only interaction type.
        circlesElementsOrNull = null;
        var lineChildElements = null;
        if (chartType === 0) {
            lineChildElements = (React.createElement(Line, __assign({ pathGenerator: pathGenerator, data: data, yAxisKey: yAxisKey, xAxisKey: xAxisKey, estimateDataPoint: estimateDataPoint }, restProps)));
        }
        else if (chartType === 1) {
            lineChildElements = React.createElement(Area, __assign({ path: areaPath }, restProps));
        }
        return (React.createElement("g", { key: key },
            lineChildElements,
            circlesElementsOrNull));
    };
    DataSeries.defaultProps = {
        title: '',
        data: [],
        interpolate: 'linear',
        color: '#ccc'
    };
    return DataSeries;
}(React.Component));
exports.default = DataSeries;
var Circles = /** @class */ (function (_super) {
    __extends(Circles, _super);
    function Circles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Circles.prototype.render = function () {
        var _a = this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, onCircleMouseOver = _a.onCircleMouseOver, onCircleMouseOut = _a.onCircleMouseOut, showCircles = _a.showCircles;
        var _b = this.props, xScale = _b.xScale, yScale = _b.yScale, seriesIndex = _b.seriesIndex, hoveredSeriesIndex = _b.hoveredSeriesIndex, data = _b.data;
        var _c = this.props, path = _c.path, color = _c.color, width = _c.width, restProps = __rest(_c, ["path", "color", "width"]);
        var circleElements = data.map(function (item, index) {
            var insideRadius = 3, outsideRadius = 4;
            var circleProps = {
                cx: xScale(item[xAxisKey]),
                cy: yScale(item[yAxisKey]),
                r: insideRadius,
                key: index,
                'data-index': index,
                'data-series-index': seriesIndex,
                onMouseOver: onCircleMouseOver,
                onMouseOut: onCircleMouseOut
            };
            var outsideCircleStyles = {
                stroke: '#212934',
                strokeWidth: '1',
                fill: 'transparent'
            };
            var insideCircleStyles = {
                stroke: 'white',
                strokeWidth: '1',
                fill: color
            };
            return (React.createElement("g", { className: "line-chart__data-points", key: index + '' + seriesIndex + circleProps.cx + circleProps.cy },
                React.createElement("circle", __assign({}, circleProps, { style: insideCircleStyles })),
                React.createElement("circle", __assign({}, circleProps, { r: outsideRadius, key: circleProps.key + 'outside', style: outsideCircleStyles }))));
        });
        if (showCircles) {
            return React.createElement("g", { className: "line-chart__data-series" }, circleElements);
        }
        else {
            return null;
        }
    };
    Circles.defaultProps = {
        path: '',
        color: 'blue',
        width: 2
    };
    return Circles;
}(React.Component));
var Area = /** @class */ (function (_super) {
    __extends(Area, _super);
    function Area() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Area.prototype.render = function () {
        var _a = this.props, path = _a.path, color = _a.color, width = _a.width, seriesIndex = _a.seriesIndex, restProps = __rest(_a, ["path", "color", "width", "seriesIndex"]);
        return (React.createElement("path", __assign({ d: path, stroke: "tranparent", strokeWidth: "0", fill: color, className: "line-chart__data-area", "data-series-index": seriesIndex }, pick_react_known_prop_1.pickSVGProps(restProps))));
    };
    Area.defaultProps = {
        path: '',
        color: 'blue',
        width: 2
    };
    return Area;
}(React.Component));
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Line.prototype.render = function () {
        var _a = this.props, path = _a.path, pathGenerator = _a.pathGenerator, data = _a.data, color = _a.color, width = _a.width, seriesIndex = _a.seriesIndex, yAxisKey = _a.yAxisKey, xAxisKey = _a.xAxisKey, estimateDataPoint = _a.estimateDataPoint, restProps = __rest(_a, ["path", "pathGenerator", "data", "color", "width", "seriesIndex", "yAxisKey", "xAxisKey", "estimateDataPoint"]);
        var foundFirstValue = false;
        var drawingDashedLines = false;
        var paths = data.map(function (value, index) {
            if (index < data.length - 1) {
                var dashArray = '';
                var pathD = pathGenerator([value, data[index + 1]]);
                // Check if the value exists in order to start drawing the line
                if (value[yAxisKey] !== undefined && value[yAxisKey] !== null) {
                    foundFirstValue = true;
                }
                // If we haven't found the first value, clear the path
                if (!foundFirstValue) {
                    pathD = '';
                }
                // Start drawing the line once we've found the first value
                if (foundFirstValue) {
                    // If the next value is undefined
                    if (data[index + 1][yAxisKey] === undefined ||
                        data[index + 1][yAxisKey] === null) {
                        // We are now drawing dashed lines
                        dashArray = '5, 10';
                        var estimatedNextDataPoint = estimateDataPoint(data, index + 1, yAxisKey, xAxisKey);
                        // If we found a real value somewhere down the line, guess the next data point
                        if (estimatedNextDataPoint !== null) {
                            // Generate the pathD with the current value and the fabricated data point.
                            pathD = pathGenerator([value, estimatedNextDataPoint]);
                            // If we didn't find another real value, we are back to not drawing a line at all.
                        }
                        else {
                            pathD = '';
                        }
                        // If the current value is missing
                    }
                    if (data[index][yAxisKey] === undefined ||
                        data[index][yAxisKey] === null) {
                        // We are still drawing dashed lines
                        dashArray = '5, 10';
                        var estimatedCurrentDataPoint = estimateDataPoint(data, index, yAxisKey, xAxisKey);
                        var estimatedNextDataPoint = estimateDataPoint(data, index + 1, yAxisKey, xAxisKey);
                        // Continue estimation as long as we've found a next value
                        if (estimatedNextDataPoint !== null) {
                            // Generate the pathD with the current value and the fabricated data point.
                            if (data[index + 1][yAxisKey] === undefined ||
                                data[index + 1][yAxisKey] === null) {
                                pathD = pathGenerator([
                                    estimatedCurrentDataPoint,
                                    estimatedNextDataPoint
                                ]);
                            }
                            else {
                                pathD = pathGenerator([
                                    estimatedCurrentDataPoint,
                                    data[index + 1]
                                ]);
                            }
                        }
                        else {
                            pathD = '';
                        }
                    }
                }
                // If the next value is missing, draw dashed lines
                if (data[index + 1][yAxisKey] === undefined ||
                    data[index + 1][yAxisKey] === null) {
                    dashArray = '5, 10';
                }
                return (React.createElement("path", __assign({ d: pathD, stroke: color, strokeWidth: width, fill: "transparent", "data-series-index": seriesIndex, className: "line-chart__data-line", key: pathD ? pathD : index * Math.random() * Math.random(), strokeDasharray: dashArray }, pick_react_known_prop_1.pickSVGProps(restProps))));
            }
            else {
                return null;
            }
        }.bind(this));
        return React.createElement("g", { className: "data-series-multi-paths" },
            " ",
            paths);
    };
    Line.defaultProps = {
        path: '',
        color: 'blue',
        width: 2
    };
    return Line;
}(React.Component));
//# sourceMappingURL=DataSeries.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/DataSeries/DataSeries.js
// module id = 364
// module chunks = 0